import {IncomeDocumentTypes} from '../constants/Common'
import {IIncomeDocument} from '../components/app/IncomeDocumentDetailPage'

export const reactSelectValue = (opts: Array<any>, id: any, key:string = 'value') => opts.find(o => o[key] === id) || null;
export const reactSelectMultiValue = (opts: Array<any>, ids: any, key:string = 'value') => {
  let values:Array<{label: string, value: any}> = [];

  (ids||[]).map((id: any)=>{
    let opt = opts.find(o => o[key] === id)
    if (!opt) opt = {value: id, label: id}

    values.push(opt)
  })

  return values
}

export const inputOnlyNumber = (e: any) => {
  if (!(/^[0-9]$/i.test(e.key) || e.metaKey || e.which <= 0 || e.which == 8 || e.keyCode == 9)) {
    e.preventDefault()
  }
}
export const inputOnlyPrice = (e: any) => {
  if (!(/^[0-9]$/i.test(e.key) || e.key === '.' || e.metaKey || e.which <= 0 || e.which == 8 || e.keyCode == 9 )) {
    e.preventDefault()
  }
}

export const getRevenuePrefixPath = (documentType: string) => {
  if (['billing', 'credit', 'debit'].includes(documentType)) {
    return `/revenue-${documentType}-note`
  }

  if (['tax-invoice', 'receipt'].includes(documentType)) {
    return `/revenue-${documentType}`
  }

  if ('deposit' === documentType) {
    return '/deposit-receipt'
  }

  return `/${documentType}`
}

export const truncateToTwoDecimals = (input: string | number): number => {
  const num = typeof input === 'number' ? input : parseFloat(input);
  if (isNaN(num)) return NaN;

  // NOTED: โอ็คเอาอันล่างออก เพราะ trunc ทำงานผิดไม่แม่นยำ
  return Number(num.toFixed(2))
  // return Math.trunc(num * 100) / 100;
};

export const getTitleLabel = (document: IIncomeDocument, trailingText?: string) => {
  const hasIssueTaxInvoice = document.issueTaxInvoice
  let titleLabel = ''

  switch (document.type) {
    case IncomeDocumentTypes.QUOTATION:
      titleLabel = `ใบเสนอราคา ${hasIssueTaxInvoice ? '/ ใบกำกับภาษี' : ''}`
      break
    case IncomeDocumentTypes.DEPOSIT:
      titleLabel = `ใบรับเงินมัดจำ ${hasIssueTaxInvoice ? '/ ใบกำกับภาษี' : ''}`
      break
    case IncomeDocumentTypes.INVOICE:
      titleLabel = `ใบแจ้งหนี้ ${hasIssueTaxInvoice ? '/ ใบกำกับภาษี / ใบส่งสินค้า' : ''}`
      break
    case IncomeDocumentTypes.RECEIPT:
      titleLabel = `ใบเสร็จรับเงิน ${hasIssueTaxInvoice ? '/ ใบกำกับภาษี / ใบส่งสินค้า' : ''}`
      break
    case IncomeDocumentTypes.TAX_INVOICE:
      titleLabel = `ใบกำกับภาษีขาย`
      break
    case IncomeDocumentTypes.CREDIT:
      titleLabel = `ใบลดหนี้/ใบกำกับภาษี`
      break
    case IncomeDocumentTypes.DEBIT:
      titleLabel = `ใบเพิ่มหนี้/ใบกำกับภาษี`
      break
    case IncomeDocumentTypes.BILLING:
      titleLabel = `ใบวางบิล ${hasIssueTaxInvoice ? '/ ใบกำกับภาษี' : ''}`
      break
    case IncomeDocumentTypes.EXPENSE_REQUEST_PURCHASE_ORDER:
      titleLabel = 'ใบขอสั่งซื้อ'
      break
    case IncomeDocumentTypes.EXPENSE_PURCHASE_ORDER:
      titleLabel = 'ใบสั่งซื้อ'
      break

    case IncomeDocumentTypes.EXPENSE_DEPOSIT_PAYMENT:
      titleLabel = 'ใบจ่ายเงินมัดจำ'
      break
    case IncomeDocumentTypes.EXPENSE_PURCHASE_INVENTORY_RECORD:
      titleLabel = 'บันทึกซื้อสินค้า'
      break
    case IncomeDocumentTypes.EXPENSE_EXPENSE_RECORD:
      titleLabel = 'บันทึกค่าใช้จ่าย'
      break
    case IncomeDocumentTypes.EXPENSE_PURCHASE_TAX_INVOICE:
      titleLabel = 'ใบกำกับภาษีซื้อ'
      break
    case IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE:
      titleLabel = 'รับใบลดหนี้'
      break
    case IncomeDocumentTypes.EXPENSE_PURCHASE_DEBIT_NOTE:
      titleLabel = 'รับใบเพิ่มหนี้'
      break
    case IncomeDocumentTypes.EXPENSE_COMBINED_PAYMENT_NOTE:
      titleLabel = 'ใบรวมจ่าย'
      break
  }

  return `${titleLabel} ${trailingText || ''}`
}

export const getIncomeDocumentPrintVolume = (document: IIncomeDocument) => {
  let originalPageTotal = 1
  let copyPageTotal = 1

  switch (document.type) {
    case IncomeDocumentTypes.QUOTATION:
    case IncomeDocumentTypes.BILLING:
    case IncomeDocumentTypes.EXPENSE_REQUEST_PURCHASE_ORDER:
      originalPageTotal = 1
      copyPageTotal = 1
      break
    case IncomeDocumentTypes.EXPENSE_PURCHASE_ORDER:
      originalPageTotal = 1
      copyPageTotal = 2
      break
    case IncomeDocumentTypes.DEPOSIT:
    case IncomeDocumentTypes.INVOICE:
    case IncomeDocumentTypes.RECEIPT:
    case IncomeDocumentTypes.CREDIT:
    case IncomeDocumentTypes.DEBIT:
      originalPageTotal = 1
      copyPageTotal = 4
      break
  }

  return {
    originalPageTotal,
    copyPageTotal,
  }
}

export const formatBankAccount = (str: string): string => {
  const digits = str.replace(/\D/g, '');
  const base = `${digits.slice(0, 3)}-${digits[3]}-${digits.slice(4, 9)}-${digits[9]}`;
  const extra = digits.slice(10);

  return base + extra;
};

export const numberFormatAccounting = (
  value: number | string,
  zeroText = '0.00',
  absValue = false
): string => {
  let n = Number(value);
  if (!Number.isFinite(n)) return zeroText;

  if (absValue) n = Math.abs(n);

  const sign = n < 0 ? '-' : '';
  const x = Math.abs(n);

  let s = String(x);
  if (s.includes('e') || s.includes('E')) {
    s = x.toFixed(20).replace(/\.?0+$/, ''); // ตัดศูนย์ท้ายที่เกิน
  }

  let [intPart, decPart = ''] = s.split('.');

  if (decPart.length === 0) decPart = '00';
  else if (decPart.length === 1) decPart = decPart + '0';

  const intWithComma = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return sign + intWithComma + '.' + decPart;
}


